export { default } from "./NotFoundContent";
